var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8.5,
    stroke: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9824 8.7793H14.6211C14.4023 6.3457 12.6182 4.96484 10.1504 4.96484C7.49121 4.96484 5.39941 6.75586 5.39258 10.0508C5.39941 13.332 7.43652 15.1367 10.1504 15.1367C13.001 15.1367 14.4775 13.168 14.6211 11.4727L11.9824 11.4453C11.8389 12.3271 11.21 12.8604 10.2051 12.8672C8.86523 12.8604 8.07227 11.9102 8.07227 10.0508C8.07227 8.28027 8.84473 7.23438 10.2188 7.23438C11.2715 7.23438 11.8936 7.84961 11.9824 8.7793Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.61eacaa26d58dab1e81497f04c427a3c.svg";
export { ForwardRef as ReactComponent };